import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MipsService } from 'src/app/services/mips.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-mips',
  templateUrl: './mips.component.html',
  styles: [
  ]
})
export class MipsComponent implements OnInit {

  @ViewChild('instructions') instructions: ElementRef;
  public questions = [];
  public texts;
  public selectedQuestion;
  public answers = [];
  public index;
  public score = {};
  public testData;
  public photoTaked = false;
  public trigger = false;
  constructor(
    private testService:TestService,
    private mipsService:MipsService, 
    private router: Router, 
  ) { 
    this.mipsService.getQuestions().subscribe(
      resp=>{
        this.questions = resp;
      },
      err=>console.log(err)
    )
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.mipsInstructions;
        }, 500)
      },
      err=>console.log(err)
    )
  }

  ngOnInit(): void {
  }

  reload(){
    location.reload()
  }

  startTest(){
    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    this.selectedQuestion = this.questions[0];
    this.index = 0;
    this.score = {};
    this.answers = [];
  }

  nextQuestion(){
      this.index = this.index + 1;
      this.selectedQuestion = this.questions[this.index];
      if(!this.selectedQuestion){
        this.trigger = !this.trigger;
        this.selectedQuestion = {
          text:"Test finalizado",  
        }
        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
        $("#myModal").modal("hide");
        this.mipsService.createReport({score:this.score, answers:this.answers}).subscribe(
          res=>{
            var testData = this.testService.selectedTestData;
            testData.isCompleted = true;
            testData.reportId = res._id;
            testData.completeDate = Date.now();
            this.testService.updateTest(testData).subscribe(
              r=>{
                this.router.navigateByUrl('dashboard/requestedTests');
              },
              e=>console.log(e)
            );
          },
          err=> console.log(err)
        )
      }
  }

  select(opc){
    if (opc==undefined){
      Swal.fire({
        text:'No respondió este ítem, puede dejarlo así, pero es conveniente responderlos todos',
        icon:'info',
        showCancelButton:true,
        confirmButtonText:'Continuar',
        cancelButtonText:'Responder'
      }).then(
        resp=>{
          if(resp.isConfirmed){
            this.answers.push(opc);
            this.nextQuestion();   
          }
        }
      )
    }else{
      this.answers.push(opc);
      this.nextQuestion();  
    }
  }

}
